import React, { useEffect } from 'react';
import { Box, Button, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { AddCircle, Refresh } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTypedDispatch, useTypedSelector } from '../../hooks';
import { getWorkstations, workstationsSelector, resetSessionsState } from '../../store/reducers';
import { WorkstationList } from '../../components/Pages/workstations';

const Workstations: React.FC = function () {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useTypedDispatch();
  const { isLoading, workstations, error } = useTypedSelector(workstationsSelector);

  useEffect(() => {
    if (!isLoading) {
      dispatch(getWorkstations());
      dispatch(resetSessionsState());
    }
  }, []);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '15px',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '15px',
        }}
      >
        <Typography variant="h6" align="left">
          Workstations
        </Typography>

        <Box>
          <Button
            variant={'outlined'}
            style={{ marginRight: '10px' }}
            color={'primary'}
            onClick={() => dispatch(getWorkstations())}
          >
            <Refresh />
          </Button>
          <Button variant="outlined" startIcon={<AddCircle />} onClick={() => navigate(`/workstations/new`)}>
            Create Workstation
          </Button>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          flexGrow: 1,
          padding: '15px',
        }}
      >
        {isLoading ? (
          <Stack spacing={1}>
            <Skeleton animation={'pulse'} variant={'text'} width={'80vw'} height={'10vh'}>
              <WorkstationList workstations={[]} />
            </Skeleton>
            <Skeleton animation={'pulse'} variant={'rectangular'} width={'80vw'} height={'65vh'}>
              <WorkstationList workstations={[]} />
            </Skeleton>
          </Stack>
        ) : (
          <WorkstationList workstations={workstations} />
        )}
      </Box>
    </Box>
  );
};

export default Workstations;
